export const ACCESS_REQUIREMENT_DEFINITIONS = [
  {
    key: 'email',
    stepLabel: 'Email confirmation',
    ctaAction: null,
  },
  {
    key: 'phone',
    stepLabel: 'Phone verification',
    ctaAction: null,
  },
  {
    key: 'kyc',
    stepLabel: 'Identity verification',
    ctaAction: 'kyc',
  },
  {
    key: 'kyb',
    stepLabel: 'Business verification',
    ctaAction: 'kyb',
  },
  {
    key: 'if',
    stepLabel: 'Account activation',
    ctaAction: null,
  },
] as const;

export type AccessRequirementDefinition = (typeof ACCESS_REQUIREMENT_DEFINITIONS)[number];
export type AccessRequirementKey = AccessRequirementDefinition['key'];
export type AccessRequirementCtaAction = Exclude<AccessRequirementDefinition['ctaAction'], null>;

export const ACCESS_REQUIREMENT_KEYS: AccessRequirementKey[] = ACCESS_REQUIREMENT_DEFINITIONS.map(
  ({ key }) => key,
);

export const getAccessRequirementDefinition = (key: AccessRequirementKey) => {
  return ACCESS_REQUIREMENT_DEFINITIONS.find((definition) => definition.key === key) ?? null;
};
